/**
 * Created by kj on 2020/12/12.
 */
import axios from 'axios'
import Toast from '../components/toast/index.js'

let params = {}

// ajax方法
export default function ajax (p) {
  let c = Object.assign({
    url: '',
    type: 'GET',
    params: {},
    loading: true
  }, p)
  return new Promise((resolve, reject) => {
      let t = null
      let timmer = null
      // 判断是否有加载
      if (c.loading) {
        t = Toast({
          type: 'loading',
          message: '数据加载中...',
          duration: 5000
        })
        if (timmer) {
          clearTimeout(timmer)
        }
      }
      axios({
        method: c.type,
        headers: {
          AppKey: '4789927066'
        },
        url: c.url.indexOf('http') !== -1 ? c.url : 'https://www.daqctc.com/api/' + c.url,
        params: Object.assign(c.params, params)
      }).then((response) => {
        if (c.loading) {
          t.show = false
        }
        resolve(response.data)
    }).catch((error) => {
        if (c.loading) {
          t.type = 'error'
          t.message = '服务器错误'
          timmer = setTimeout(() => {
              t.show = false
          }, 1000)
        }
        reject(error)
    })
  })
}



// WEBPACK FOOTER //
// ./src/service/fetch-healthy.js